// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__91s4E","code":"ErrorPage_code__jcPCD","text":"ErrorPage_text__s7JUW"};